import React from 'react';
// import { useForm } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import { FIELDS, STEPS } from '../utils/constants';
import { useFormStateContext } from '../utils/hooks';
import {
  InputField,
  InputError,
  InputContainer,
  InputLabel,
  Flex,
  Button,
} from '../utils/styles';

export const ErrorStep = () => {
  const { fields, setStep, updateFields } = useFormStateContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { errorstep: fields.errorstep } });

  // const goBack = () => {
  //   setStep(STEPS.MOBILE);
  // };

  const onSubmit = (data) => {
    // console.log(data);
    // updateFields(FIELDS.ERROR, data.errorstep);
    setStep(STEPS.EMAIL);
  };

  const onError = (errors, event) => {
    console.log(errors);
    console.log(event);
  };

  return (
    <div className="base-form">
      {/* <form onSubmit={handleSubmit(onSubmit, onError)}> */}
      <form onSubmit={handleSubmit(onSubmit, onError)}>
      <div className='button-back'>
          <Button
            type="button"
            children="Back"
            secondary
            style={{ margin: '0 10px' }}
           
          > </Button>  
          <h4>The user already exists</h4>    
        </div> 
        <div className="f-container"> 
         
          <h1 className='text-danger rejtion-title'>User already exists please use another email address</h1>
           
          {/* <div className='button-next'>
             <a href="/?login"  children="" >Change <span className="enter">Email</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></a>
          </div> */}

          <div className='button-next'>
            <Button children="Next">Change <span className="enter">Email</span>  <i class="fa fa-angle-right" aria-hidden="true"></i></Button>
          </div>


          <p class="hidden-xs">&nbsp;</p>
          <div class="terms5">
            <p className='text-center'> Already have an account with us? <a href="/login">Please Sign In</a>
            </p>
          </div>



        </div>
      </form>
    </div>
  );
};













